<template>
  <iColumn align="center">
    <iText>Please sign into your Account</iText>
    <iTextInput
      v-model="userAuthEmail"
      disabled
      width="fill"
      right-icon="pencil"
      focus
      @click-icon-right="goBackToEmailStep"
    />
    <iTextInput
      v-model="password"
      type="password"
      width="fill"
      focus
      @enter="login"
    />
    <iText v-if="loginErrorMessage" variant="error">
      {{ loginErrorMessage }}
    </iText>
    <iButton
      :is-loading="isLoading"
      loading-spinner-position="inside"
      :disabled="isLoading"
      @click="login"
    >
      Continue
    </iButton>
    <iLink @click="forgotPassword">
      Forgot password?
    </iLink>
    <iSpace :height="40" width="fill" />
    <PoweredByInspiration />
  </iColumn>
</template>

<script>
import PoweredByInspiration from "%/dynamic-component-editor/standard-pages/login-signup-page/join-publication/PoweredByInspiration.vue";
import { mapState, mapWritableState } from "pinia";
import { useLoginSignupStore } from "%/dynamic-component-editor/stores/login-signup-store";
import { FORGOT_PASSWORD_FORM } from "%/dynamic-component-editor/constants/login-flow-constants";

export default {
  name: "JoinPublicationPassword",
  components: { PoweredByInspiration },
  data() {
    return {
      password: "",
    };
  },
  computed: {
    ...mapWritableState(useLoginSignupStore, ["userAuthEmail", "userFlowSteps", "loginErrorMessage"]),
    ...mapState(useLoginSignupStore, ["isLoading"]),
  },
  mounted() {
    this.loginErrorMessage = "";
  },
  methods: {
    login() {
      useLoginSignupStore().loginUser(this.password, 1);
    },
    goBackToEmailStep() {
      this.userFlowSteps.pop();
    },
    forgotPassword() {
      this.userFlowSteps.push(FORGOT_PASSWORD_FORM);
    },
  },
};
</script>
